var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "productQuotationApplicationAdd container" },
    [
      _c(
        "div",
        { staticClass: "searchBox" },
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Sourcing - _vm.productSubmit,
                      expression: "Sourcing-productSubmit",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.submitData },
                },
                [_vm._v("提交")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.goBack },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "applyInfoForm",
              staticStyle: { "margin-top": "20px" },
              attrs: {
                "label-width": "140px",
                model: _vm.headData,
                inline: "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "报价确认单据编号" } },
                [
                  _c("el-input", {
                    staticClass: "handle-input",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.headData.sourcingNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.headData, "sourcingNo", $$v)
                      },
                      expression: "headData.sourcingNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "产品报价申请单" } },
                [
                  _c("el-input", {
                    staticClass: "handle-input",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.headData.applyNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.headData, "applyNo", $$v)
                      },
                      expression: "headData.applyNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "主题" } },
                [
                  _c("el-input", {
                    staticClass: "handle-input",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.headData.subject,
                      callback: function ($$v) {
                        _vm.$set(_vm.headData, "subject", $$v)
                      },
                      expression: "headData.subject",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "ux-grid",
        {
          ref: "proList",
          attrs: {
            data: "proList",
            "max-height": "650",
            "show-overflow": "tooltip",
            "highlight-current-row": "",
          },
        },
        [
          _c("ux-table-column", {
            attrs: { align: "center", type: "checkbox", width: "80" },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "序号",
              type: "index",
              width: "60",
            },
          }),
          _vm._l(_vm.columns, function (item, index) {
            return _c("ux-table-column", {
              key: index,
              attrs: {
                align: "center",
                resizable: "",
                field: item.prop,
                title: item.label,
                sortable: "",
                "min-width": item.width,
              },
            })
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "非标准线路运费",
              field: "isSpecialFreight",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("setIsSpecialFreight")(
                            scope.row.isSpecialFreight
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "到货仓库",
              field: "tmDcId",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("ic")(scope.row.tmDcId, "BASE", "DC")) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "温区",
              field: "temperature",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.temperature,
                            "COMMON",
                            "TEMPERATURE"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.columns1, function (item, index) {
            return _c("ux-table-column", {
              key: index,
              attrs: {
                align: "center",
                resizable: "",
                field: item.prop,
                title: item.label,
                sortable: "",
                "min-width": item.width,
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }